import React from 'react';
import Layout from '../components/Layout';
import { Tv, ExternalLink } from 'lucide-react';

export default function LeMieApp() {
  return (
    <Layout title="Le mie App" showBack backTo="/home">
      <div className="px-5 pt-6 max-w-md mx-auto space-y-4">
        <h2 className="font-heading text-2xl font-light">Le tue applicazioni</h2>
        <p className="text-sm text-white/60">
          Accedi rapidamente alle app Golden TV installate sul tuo dispositivo.
        </p>

        <a
          data-testid="open-golden-app-btn"
          href="https://goldentv123.github.io/GOLDEN-APP/"
          target="_blank"
          rel="noopener noreferrer"
          className="card-surface p-5 flex items-center gap-4 hover:border-[var(--gold)]/50 block"
        >
          <div className="w-14 h-14 rounded-2xl bg-[var(--gold-soft)] border border-[var(--gold)]/30 flex items-center justify-center">
            <Tv className="w-7 h-7 text-[var(--gold)]" strokeWidth={1.5} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-heading font-medium text-white">Golden App</div>
            <div className="text-xs text-white/50 mt-1">Applicazione principale</div>
          </div>
          <ExternalLink className="w-4 h-4 text-white/40" />
        </a>

        <div className="card-surface p-5">
          <div className="text-xs uppercase tracking-widest text-white/40 mb-2">Suggerimento</div>
          <p className="text-sm text-white/70 leading-relaxed">
            Se non hai ancora installato le app, vai su <span className="text-[var(--gold)]">Guida al Download</span> per le istruzioni passo passo.
          </p>
        </div>
      </div>
    </Layout>
  );
}
